import { render, staticRenderFns } from "./PageSubmitEvidence.vue?vue&type=template&id=25c3f904&scoped=true&"
import script from "./PageSubmitEvidence.vue?vue&type=script&lang=js&"
export * from "./PageSubmitEvidence.vue?vue&type=script&lang=js&"
import style0 from "./PageSubmitEvidence.vue?vue&type=style&index=0&id=25c3f904&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c3f904",
  null
  
)

export default component.exports